export {pillar};

class pillar {
    x_coord: number;
    upper_corner: number;
    space_height: number;
    context: CanvasRenderingContext2D;
    seen: boolean;

    constructor(x: number, height: number, context: CanvasRenderingContext2D) {
        this.x_coord = x;
        this.upper_corner = height * 400;
        this.space_height = 400;
        this.context = context;
        this.seen = false;
    }

    move(x_dist: number) {
        this.x_coord -= x_dist;
    }

    draw(window_height: number) {
        this.context.fillStyle = "darkGreen";
        this.context.fillRect(this.x_coord, 0, 150, window_height);
        this.context.fillStyle = `hsl(195, 92%, 75%)`;
        this.context.fillRect(this.x_coord, this.upper_corner, 150, this.space_height);
    }
}